// extracted by mini-css-extract-plugin
export var backdropBlur = "_cj-0";
export var contentCard = "_cj-5";
export var frame = "_cj-2";
export var image = "_cj-4";
export var imagePane = "_cj-3";
export var modal = "_cj-1";